import { useConfig } from "../../config/ConfigContext";
import { formatCheckoutMoney } from "../../utils/formatPrice";

export default function CheckoutCartItem({ item }) {
  const config = useConfig();
  return (
    <div className="os-item">
      <div className="os-item-l">
        <span className="os-item-ico">🛟</span>
        <img
          src={item.toy.fields["Photos"][0].url}
          alt={item.toy.fields["Name"]}
          className="w-10 h-10 rounded-lg object-cover"
        />
        <div>
          <div className="os-item-name">{item.toy.fields["Name"]}</div>
          <div className="os-item-qty">x {item.quantity}</div>
        </div>
      </div>
      <div className="os-item-price">
        {formatCheckoutMoney(
          item.quantity * item.toy.fields[config.itemPriceFieldTTC],
        )}{" "}
        €
      </div>
    </div>
  );
}
